import React from 'react'
import styles from './school-details-sub-ft.styles'
import injectSheet from 'react-jss'
import FormRow from '../../../shared/details/form-row/form-row'
import FormCell from '../../../shared/details/form-cell/form-cell'
import FormLabel from '../../../shared/details/form-label/form-label'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import FormSelect from 'pobble-components/dist/form-elements/form-select'
import { Formik } from 'formik'
import Button from 'pobble-components/dist/button'
import * as Yup from 'yup'

const requiredMsg = 'This field should not be empty'

const SchoolDetailsSubFT = ({ classes, onSubmit, id }) => (
  <div>
    {id && (
      <Formik
        onSubmit={onSubmit}
        initialValues={{
          plan: '',
          contactEmailAddress: '',
          financeContactAddress: '',
          price: ''
        }}
        validationSchema={Yup.object().shape({
          plan: Yup.string().required(requiredMsg),
          contactEmailAddress: Yup.string().required(requiredMsg),
          financeContactAddress: Yup.string(),
          price: Yup.string()
        })}>
        {formikProps => {
          const {
            values,
            handleBlur,
            handleChange,
            handleSubmit,
            isValid,
            touched,
            errors
          } = formikProps
          return (
            <form onSubmit={handleSubmit}>
              <FormRow>
                <FormCell>
                  <FormLabel>Assign a 4 weeks school free-trial</FormLabel>
                  <FormSelect
                    name="plan"
                    value={values.plan}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    validationError={touched.plan && errors.plan}>
                    <option value="">-</option>
                    <option value="pobble-school-a">
                      T&L (pobble-school-a)
                    </option>
                    <option value="pobble-school-b">
                      Moderation (pobble-school-b)
                    </option>
                    <option value="pobble-school-ab">
                      T&L + Moderation (pobble-school-ab)
                    </option>
                  </FormSelect>
                </FormCell>
                <FormCell>
                  <FormLabel>Contact email address</FormLabel>
                  <FormInput
                    name="contactEmailAddress"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.contactEmailAddress}
                    placeholder={'Ex: jondoe@school.uk'}
                    validationError={
                      touched.contactEmailAddress && errors.contactEmailAddress
                    }
                  />
                </FormCell>
                <FormCell>
                  <FormLabel>Finance contact address</FormLabel>
                  <FormInput
                    name="financeContactAddress"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.financeContactAddress}
                    placeholder={'Ex: jondoe@school.uk'}
                    validationError={
                      touched.financeContactAddress &&
                      errors.financeContactAddress
                    }
                  />
                </FormCell>
                <FormCell>
                  <FormLabel>Price (optional)</FormLabel>
                  <FormInput
                    name="price"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.price}
                    placeholder={'Ex: 200 (currency based on country)'}
                    validationError={touched.price && errors.price}
                  />
                </FormCell>
                <FormCell>
                  <Button
                    className={classes.submitButton}
                    disabled={!isValid}
                    type="submit"
                    tall>
                    Create and assign free-trial
                  </Button>
                </FormCell>
              </FormRow>
            </form>
          )
        }}
      </Formik>
    )}
  </div>
)

export default injectSheet(styles)(SchoolDetailsSubFT)
